export const libraryQueryParams = (toMode, route) => {
  const postLibraryModes = ['published', 'unpublished', 'draft', 'email', 'flagship'];
  const reqLibraryModes = ['draft-requisitions', 'open-requisitions', 'closed-requisitions'];
  const jobProfileLibraryModes = [
    'employee-acknowledgements',
    'active-job-profiles',
    'inactive-job-profiles',
    'draft-job-profiles',
    'job-profile-templates',
  ];

  const isToPostLibraryPage = postLibraryModes.includes(toMode);
  const isToReqLibraryPage = reqLibraryModes.includes(toMode);

  const fromMode = route.name;
  const isFromPostLibraryPage = postLibraryModes.includes(fromMode);
  const isFromReqLibraryPage = reqLibraryModes.includes(fromMode);
  let query = {};

  // Don't carry any filters when navigating from outside the libraries (e.g. Platform Permissions)
  if (!isFromPostLibraryPage && !isFromReqLibraryPage) {
    return query;
  }

  if ((isToPostLibraryPage && isFromPostLibraryPage)
      || (isToReqLibraryPage && isFromReqLibraryPage)
  ) {
    query = { ...route.query };

    delete query.sort;
    delete query.page;

    if (toMode === 'flagship' && query.owned) {
      delete query.owned;
    }

    if (toMode === 'flagship' && query.internal) {
      delete query.internal;
    }

    if (toMode === 'flagship' && query.evergreen) {
      delete query.evergreen;
    }

    if (toMode === 'flagship' && query.department) {
      delete query.department;
    }

    if (fromMode === 'flagship' && query.visibility) {
      delete query.visibility;
    }

    return query;
  }

  if (jobProfileLibraryModes.includes(toMode)) {
    return query;
  }

  if (route.query.owned) {
    query.owned = route.query.owned;
  }

  if (route.query.q) {
    query.q = route.query.q;
  }

  return query;
};
